import { useQuery } from '@tanstack/react-query';
import { billingApi, MyMembership } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';

/**
 * The signed-in member's plan access. `needsPlan(perk)` is true only when the
 * studio sells memberships and this member's plans don't include the perk —
 * on every other studio it's always false, so callers can gate unconditionally.
 */
export function useMembership() {
  const { user } = useAuth();
  const tenant = useTenant();
  const enabled = !!user && !!tenant?.membershipsEnabled;
  const query = useQuery<MyMembership>({
    queryKey: ['billing', 'me', user?.email],
    queryFn: billingApi.getMine,
    enabled,
    staleTime: 60_000,
  });
  const me = query.data;
  return {
    membershipsEnabled: !!tenant?.membershipsEnabled,
    membership: me,
    isLoading: enabled && query.isLoading,
    refetch: query.refetch,
    needsPlan: (perk: 'library' | 'feedback' | 'live') => enabled && !!me && !me.perks[perk],
  };
}
